import { EismItem, PageWrapper } from '@src/components';
import { useLazyGetHistoryEsimsQuery } from '@src/services/esim/esimApiSlice';
import { useEffect } from 'react';
import { EmptyList } from './EmptyList';
import { CardsSkeleton } from '@src/components/Loading/CardsSkeleton';

export function HistoryView() {
  const [getHistory, { data, isLoading }] = useLazyGetHistoryEsimsQuery();

  useEffect(() => {
    getHistory({});
  }, []);

  if (isLoading) return <CardsSkeleton numberOfItems={2} />;

  return (
    <PageWrapper>
      {data?.items?.length ? (
        <div className='grid gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3'>
          {data?.items?.map((esim) => {
            return (
              <EismItem
                mode='history'
                key={esim.esimId}
                esim={esim}
                packageIsAvailable={esim.packageIsAvailable}
              />
            );
          })}
        </div>
      ) : (
        <EmptyList />
      )}
    </PageWrapper>
  );
}
